import { Flex } from "rebass";
import styled from "styled-components";

export const BaseSection = styled(Flex)`
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.colors.chalkAlpha20};
  gap: 36px;
  padding: 24px;
`;
